/**
 * format file size to displayable text
 * @param size number
 */
export default function formatFileSize(size: number | undefined | null) {
  // sanity check
  if (size === undefined || size === null) {
    // TODO: need to confirm the text
    return "Unknown";
  }

  return size >= 1024 * 1024 * 1024
    ? `${(size / 1024 / 1024 / 1024).toFixed(0)} GB`
    : size >= 1024 * 1024
    ? `${(size / 1024 / 1024).toFixed(0)} MB`
    : size >= 1024
    ? `${(size / 1024).toFixed(0)} KB`
    : `${size.toFixed(0)} B`;
}
